<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Abonelik Formları">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table">
                  <thead>
                    <th>#</th>
                    <th>Ad Soyad</th>
                    <th>E-Posta</th>
                    <th>Tarih</th>
                  </thead>
                  <tr v-for="form in forms" :key="form.id">
                    <td>{{ form.id }}</td>
                    <td>{{ form.name }} {{ form.surname }}</td>
                    <td>{{ form.email }}</td>
                    <td>{{ form.createdAt }}</td>
                  </tr>
                  <thead>
                    <th>#</th>
                    <th>Ad Soyad</th>
                    <th>E-Posta</th>
                    <th>Tarih</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="1"
                    :total-rows="rows"
                    :per-page="12"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getFormNewsletters(value)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    target="_blank"
                    :href="`${baseUrl}/api/v1/export/forms/newsletters?startDate=${startDate}&endDate=${endDate}`"
                  >
                    Dışa Aktar
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BPagination,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      forms: [],
      rows: 100,
      currentPage: 1,
      analysisResults: [],
      baseUrl: settings.apiBaseUrl,
      startDate: null,
      endDate: null,
      locale: this.$i18n.locale,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getFormNewsletters(newVal);
      },
      deep: true,
    },
  },
  methods: {
    getFormNewsletters(page) {
      endpoints
        .getFormNewsletters(
          page,
          this.startDate,
          this.endDate,
          this.$i18n.locale,
          () => {}
        )
        .then((data) => {
          this.forms = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getFormNewsletters(1);
  },
};
</script>
